import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import { isDev } from './devUtils';
import {
  hasExtensionReferenceInBreadCrumbs,
  hasExtensionReferenceInHintErrorStack,
  hasExtensionReferenceInEventErrorStack
} from './sentry.helper';

// List of pages that have the same pathname but different variants controlled with
// search params. Pages added to this list will have the search param added to the name
// during tracing (performance tracking)
const PAGES_WITH_VARIANTS = ['/onboarding/continue'];

if (!window.StravaSentryDsn) {
  window.StravaSentryDsn = {};
}
if (!window.StravaSentryDsn.deferred) {
  window.StravaSentryDsn.deferred = {};
  const promise = new Promise(
    function _(resolve, reject) {
      this.doResolve = resolve;
      this.doReject = reject;
    }.bind(window.StravaSentryDsn.deferred)
  );
  window.StravaSentryDsn.deferred.then = promise.then.bind(promise);
}

const { enabled, environment, release, userId, dsn, sampleRate, debug } =
  window.StravaSentry || {};

window.StravaSentryDsn.deferred.doResolve(dsn);

window.StravaSentryDsn.deferred.then((_dsn) => {
  // configure sentry_frontend.yml to enable sentry on local
  if (enabled) {
    Sentry.init({
      dsn: _dsn,
      maxBreadcrumbs: 50,
      integrations: [
        new BrowserTracing({
          tracingOrigins: [
            'https://www.staging.strava.com',
            'https://www.strava.com',
            'localhost',
            /^\//
          ],
          beforeNavigate: (context) => {
            const { pathname, search } = window.location;
            const includeSearchParam = PAGES_WITH_VARIANTS.includes(pathname);
            return {
              ...context,
              name: includeSearchParam ? pathname.concat(search) : pathname
            };
          }
        })
      ],
      denyUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
      ],
      tracesSampleRate: sampleRate,
      debug,
      attachStacktrace: true,
      release,
      initialScope: {
        user: { id: userId }
      },
      environment,
      beforeSend: (event, hint) => {
        if (
          hasExtensionReferenceInHintErrorStack(hint) ||
          hasExtensionReferenceInBreadCrumbs(event) ||
          hasExtensionReferenceInEventErrorStack(event)
        ) {
          return null;
        }
        return event;
      }
    });
  }
});

export const logError = (err) => {
  if (isDev()) {
    // eslint-disable-next-line no-console
    console.error('logError :::', err);
    return;
  }
  Sentry.captureException(err);
};

export const logMessage = (message) => {
  if (isDev()) {
    // eslint-disable-next-line no-console
    console.log('logMessage :::', message);
    return;
  }
  Sentry.captureMessage(message);
};

export default { logError, logMessage };
